import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import PageTitleWithBackButton from '../../components/PageTitleWithBackButton/PageTitleWithBackButton';
import {
  translate,
} from '../../helperFunctions/translation';
import styles from './style.module.scss';
import { ICustomerServiceStore, CustomerServiceDay, TimeEdge } from '../../mobx-store/storeInterfaces/customerServiceStoreInterface';
import CustomerServiceWorkingDay from '../../components/CustomerServiceWorkingDayComponent';
import Button from '@material-ui/core/Button';
import Spinner from '../../components/Spinner';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import { CountryStore } from '../../mobx-store/stores/countryStore';

interface IProps extends WithSnackbarProps {
  customerServiceStore: ICustomerServiceStore;
  countryStore: CountryStore;
  history: any;
}

interface State {
  data: CustomerServiceDay[];
  disabled: boolean;
  isSaving: boolean;
  loadingManagedCountries: boolean;
}


@inject('customerServiceStore')
@inject('countryStore')
@observer
class CustomerServiceWorkingHours extends Component<IProps, State> {

  title: string;

  constructor(props: IProps) {
    super(props);
    this.title = translate('customerServiceManagement', {
    });
    this.state = {
      data: [],
      loadingManagedCountries: true,
      disabled: false,
      isSaving: false,
    };
  }

  toggleDayAvailability = (index: number) => {

    const data = this.state.data;
    data[index].isOpen = !data[index].isOpen;
    if(!data[index].isOpen) {
      data[index].startTime = null;
      data[index].endTime = null;
    }
    this.setState({data}, () => {
      this.canSubmit();
    })
  }

  onChangeTime = (index: number, edge: TimeEdge, val: string) => {
    const data = this.state.data;
    data[index][edge] = !!val? val+':00' : undefined;
    this.setState({data}, () => {
      this.canSubmit();
    });  
  }

  canSubmit = () => {
    for(var i=0; i<this.state.data.length; i++) {
      const slot: CustomerServiceDay = this.state.data[i];
      if(!slot.isOpen || (slot.isOpen && !!slot.startTime && !!slot.endTime)) {
        this.setState({disabled: false})
      } else {
        this.setState({disabled: true});
        break;
      }
    }
  }

  renderWeekDays = () => {
    
    return this.state.data.map((slot: CustomerServiceDay, i) => {
      
      const isValid: boolean = (slot.isOpen && !!slot.startTime && !!slot.endTime) || !slot.isOpen;

      return (
        <CustomerServiceWorkingDay 
          key={i} 
          day={slot.day} 
          isOpen={slot.isOpen} 
          index={i}
          isValid={isValid}
          onToggle={(index) => this.toggleDayAvailability(index)}
          onChangeTime={(edge: TimeEdge, val: string) => this.onChangeTime(i, edge, val)}
          startTime={slot.startTime}
          endTime={slot.endTime}
        />
      )
    })
  }

  onSubmit = async () => {
    try {
      this.setState({isSaving: true});
      await this.props.customerServiceStore.updateWorkingHours(this.state.data);
      SnackBarComponent.getInstance().openSnackbar(translate('workingHoursSavedSuccessfully', {}), 3000, 'success');
    } catch(error) {
      SnackBarComponent.getInstance().openSnackbar(translate('errorSavingWorkingHours', {}), 3000, 'error');
    } finally {
      this.setState({isSaving: false});
    }
  }

  async componentWillMount() {
    const {
      countryStore,
      customerServiceStore
    } = this.props;
    await countryStore.getUserManagedCountries();
    await customerServiceStore.getWorkingHours(countryStore.managedCountries);
    this.setState({
      data: customerServiceStore.workingHours,
      loadingManagedCountries: false
    });
  }

  render() {
        
    return (this.props.customerServiceStore.loading || this.state.loadingManagedCountries)? 
    <Spinner /> :
    (
      <div>
        <PageTitleWithBackButton history={this.props.history} pageTitle={this.title} />
        <div className={styles.body}>
          <p className={styles.hours}>{translate('hours', {})}</p>
          {this.renderWeekDays()}
          <Button
            variant="contained"
            className={styles.submit}
            color="primary"
            onClick={() => this.onSubmit()}
            type="button"
            disabled={this.state.disabled}
          >
            {this.state.isSaving? <Spinner /> : translate('Submit', {})}
          </Button>

        </div>
      </div>
    );
  }

}

export default CustomerServiceWorkingHours;
